import { HOME_PATH } from 'dpl/shared/constants/urls';
import { VERIFY_DEVICE } from 'dpl/constants/query_params';

export default function deviceVerificationRedirect() {
  window.location = `${HOME_PATH}?${VERIFY_DEVICE}=true`;
}
